import { createApi, fetchBaseQuery, SkipToken } from '@reduxjs/toolkit/query/react';

import { scanningConfig } from '../../Config';
import { getToken } from '../../helpers/AuthHelpers';
import { AuthData } from '../../types/Api';
import { User } from '../../types/User';

export const AuthAPI = createApi({
    reducerPath: 'AuthAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${scanningConfig.apiPath}/`,
        prepareHeaders: (headers) => {
            const token = getToken('idToken');
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            headers.set('Camel-Case', 'true');
            return headers;
        }
    }),
    tagTypes: ['User'],
    endpoints: (builder) => ({
        loginAccessTokens: builder.query<AuthData, { code: string | null }>({
            query: ({ code }) => ({
                url: `/auth/tokens-from-cognito-code?code=${code}&redirect=${encodeURIComponent(
                    import.meta.env.VITE_SCANNING_COGNITO_REDIRECT_PATH ?? ''
                )}`,
                method: 'GET'
            })
        }),
        refreshAccessToken: builder.mutation<any, { refreshToken: string | null }>({
            query: (refreshToken) => ({
                url: '/auth/refresh-tokens',
                method: 'POST',
                body: {
                    refresh_token: refreshToken
                }
            })
        }),
        getUser: builder.query<User, boolean | SkipToken | void>({
            query: () => ({ url: '/auth/user' }),
            providesTags: ['User']
        })
    })
});

export const { useLoginAccessTokensQuery, useGetUserQuery, useRefreshAccessTokenMutation } = AuthAPI;
